import { useQuery } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'
import type { DiscoveryKind, DiscoveryModality, LabVendor } from './discoveryTypes'

// lat/lon omitted together = coordinate-free legacy search (ZIP could not be geocoded).
export type DiscoverySearchInput = {
  lat?: number
  lon?: number
  radiusMiles: 25 | 50
  kind?: DiscoveryKind
  /** Required when kind is 'lab' — the server has no brand to search without it. */
  vendor?: LabVendor
  modality?: DiscoveryModality
  query?: string
  /** 'state' searches the patient's whole state by facility name instead of the radius. */
  scope?: 'radius' | 'state'
  state?: string
}

export function useFacilityDiscovery(input: DiscoverySearchInput | null) {
  const orpc = useOrpc()
  return useQuery({
    ...orpc.facilityDiscoverySearch.queryOptions({
      input: input ?? { radiusMiles: 25 },
    }),
    enabled: input !== null,
    staleTime: 60_000,
    retry: 1,
  })
}
